import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d8f18368&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f18368')) {
      api.createRecord('d8f18368', component.options)
    } else {
      api.reload('d8f18368', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d8f18368&", function () {
      api.rerender('d8f18368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/receipt/index.vue"
export default component.exports